<template>
  <div class="flex w-full gap-4" :id="unicId">
    <input
      :type="type"
      class="w-full h-full border rounded-xl bg-white border-neutral-200 text-2xl  text-center"
      required
      maxlength="1"
      v-for="el in nbChar"
    />
    <div class="hidden">
      <input v-model="inputText" ref="textInput" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { OTPInputHandler } from './otpInput/OTPInputHandler';

export default defineComponent({
  name: 'SelectInput',
  components: {},
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
    modelValue: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
    preventKeyDown: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    detailText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeHolder: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    alwaysShowPrefix: {
      type: Boolean,
      default: false
    },
    alwaysShowSuffix: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Function,
      default: () => {
        return '';
      }
    },
    nbChar: {
      type: Number,
      default: () => {
        return 5;
      }
    }
  },
  data() {
    return {
      fileTypes: {
        png: 'image/png',
        jpg: 'image/jpg',
        jpeg: 'image/jpeg',
        pdf: 'application/pdf'
      },
      unicId: `component-${Date.now()}`,
      inputText: ''
    };
  },
  mounted() {
    this.initOtpHandler();
  },
  methods: {
    initOtpHandler() {
      const otpHandler = new OTPInputHandler(`#${this.unicId}>input`);
      otpHandler.onInputEvent((newValue) => {
        this.inputText = newValue;
      });
    },
    externalSetValue(newValue) {
      console.log(newValue);
    }
  },
  watch: {
    inputText(val) {
      this.$emit('input', val);
      this.$emit('input:modelValue', val);
      this.$emit('update:modelValue', val);
    }
  },
  computed: {}
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url(./otpInput/style.css);
</style>
